import { render, staticRenderFns } from "./Dowjones.vue?vue&type=template&id=28142082&"
import script from "./Dowjones.vue?vue&type=script&lang=js&"
export * from "./Dowjones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports